module.exports = __webpack_public_path__ + "public/img/Menyusun Surat Bisnis dalam Bahasa Inggris Bagi Calon Sekretaris.58fd4971.png";